import type { CSSProperties, ReactElement } from 'react'
import { useRef, useState } from 'react'

import { useDisposableLayoutEffect } from './useDisposableEffect'

export const useOverlayElement = <T extends HTMLElement = HTMLElement>(init: (style: CSSProperties) => ReactElement) => {
  const ref = useRef<T>(null)
  const [style, setStyle] = useState<CSSProperties>({
    width: '0px',
    height: '0px',
    top: '0px',
    left: '0px',
    position: 'absolute',
  })

  useDisposableLayoutEffect(stack => {
    if (!ref.current) return
    const obs = new ResizeObserver(entries => {
      const entry = entries.at(0)!
      const target = entry.target as HTMLDivElement
      const rect = entries.at(0)!.contentRect
      setStyle({
        width: rect.width + 'px',
        height: rect.height + 'px',
        top: target.offsetTop + 'px',
        left: target.offsetLeft + 'px',
        position: 'absolute',
      })
    })

    obs.observe(ref.current)
    stack.defer(() => {
      obs.disconnect()
    })
  }, [])

  return [ref, init(style)] as const
}
